<template>
    <div component="RatingBanner" :open="open">
        <div container type="vertical" valign="center">
            <div class="button open" color="transparent" @click="open = !open">
                <!--   <div class="caption">Rating</div>
                <div class="value">{{ computedRating }}</div> -->
                <div class="icons">
                    <div class="icon" v-if="!open">keyboard_arrow_down</div>
                    <div class="icon" v-if="open">close</div>
                </div>
            </div>
            <div block="rating">
                <div class="cell caption">
                    <div class="cell icon"></div>
                    <div>Rating</div>
                </div>
                <div class="cell value">{{ getActorRating.pocet_klikov }}</div>
                <div
                    class="infos"
                    @mouseenter="showTooltip"
                    @mouseleave="hideTooltip"
                    @click.stop="showTooltip"
                    for="rating"
                >
                    i
                </div>
            </div>
            <div block="win">
                <div class="cell caption">
                    <div class="cell icon">
                        <nav-button
                            :class="'btn'"
                            :link="'/profile/winning-rating-list'"
                            :color="'ghost'"
                            :size="'icon'"
                            :icon="'search'"
                        ></nav-button>
                    </div>
                    <div>Winning rating</div>
                </div>
                <div class="cell value">{{ getActorRating.pocet_vitazstiev }}</div>
                <div
                    class="infos"
                    @mouseenter="showTooltip"
                    @mouseleave="hideTooltip"
                    @click.stop="showTooltip"
                    for="win"
                >
                    i
                </div>
            </div>
            <div block="short">
                <div class="cell caption">
                    <div class="cell icon">
                        <nav-button
                            :class="'btn'"
                            :link="'/profile/shortlist-rating'"
                            :color="'ghost'"
                            :size="'icon'"
                            :icon="'search'"
                        ></nav-button>
                    </div>
                    <div>Shortlist rating</div>
                </div>
                <div class="cell value">{{ getActorRating.pocet_vyberov }}</div>
                <div
                    class="infos"
                    @mouseenter="showTooltip"
                    @mouseleave="hideTooltip"
                    @click.stop="showTooltip"
                    for="short"
                >
                    i
                </div>
            </div>
            <div block="top">
                <div class="cell caption">
                    <div class="cell icon"></div>
                    <div>TOP 30</div>
                </div>
                <div class="cell value" :class="{ recalculate: isAdmin }" @click="recalculate">
                    <i class="icon load" v-if="loading">load</i>
                    <template v-else>{{ getActorRating.top_30_filtered }}</template>
                </div>
                <div
                    class="infos"
                    @mouseenter="showTooltip"
                    @mouseleave="hideTooltip"
                    @click.stop="showTooltip"
                    for="top"
                >
                    i
                </div>
            </div>
        </div>
        <!-- tooltip -->
        <div ref="tooltip" class="tooltip" :style="{ top: getTooltip.top }">
            <div class="text">
                {{ getTooltip.text }}
            </div>
        </div>
    </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import { StatsApi } from '@/api';

export default {
    name: 'RatingBanner',

    props: {
        actor: {
            type: Object,
            required: true,
        },
    },

    methods: {
        ...mapActions(['recalculateTop30']),

        showTooltip(event, code) {
            const button = event.currentTarget;
            const index = button.getAttribute('for');

            this.tooltip = {
                text: this.texts[index],
                top: this.offset(button).top,
                left: this.offset(button).left,
            };

            this.$refs.tooltip.style.top = this.offset(button).top + 'px';
            this.$refs.tooltip.classList.add('visible');
        },

        hideTooltip(event) {
            this.$refs.tooltip.classList.remove('visible');
        },

        offset(el) {
            var rect = el.getBoundingClientRect(),
                scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
                scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            return { top: rect.top + scrollTop, left: rect.left + scrollLeft };
        },

        recalculate(el) {
            if (!this.isAdmin || this.loading) {
                return;
            }

            this.loading = true;

            return StatsApi.recalculateTop30()
                .then((response) => {
                    this.$store.dispatch('whoAmI');
                    this.loading = false;
                })
                .catch((err) => {});
        },
    },

    computed: {
        ...mapGetters(['getActorRating', 'getIsLoggedIn', 'hasRole', 'getUser']),

        getTooltip() {
            return this.tooltip;
        },

        isAdmin() {
            return this.getIsLoggedIn && this.hasRole('role_administrator');
        },
    },

    data() {
        return {
            open: false,
            texts: {
                rating: 'How many times have clients listened to your voice?',
                short: 'How many times was your voice nominated for shortlist?',
                win: 'How many times was your voice approved for Recording?',
                top: 'Your position in TOP 30 most wanted voices.',
            },

            tooltip: {},

            loading: false,
        };
    },

    components: {},
};
</script>
<style lang="less" scoped>
@import '~@variables';

[component='RatingBanner'][template='simple'] {
    position: relative;
    height: auto;
    width: auto;
    left: auto;
    overflow: visible;
    border-radius: 0;

    [container] {
        height: auto;
        position: relative;
        background-color: transparent;

        &:after {
            left: 61%;
            top: 13px;
            right: 50px;
        }
    }

    .button.open {
        display: none;
    }

    [block] {
        padding-right: 0px;
    }
}

[component='RatingBanner'] {
    position: absolute;
    width: 100%;
    top: 0px;
    width: 80%;
    height: calc(80% - 10px);
    left: 10%;
    border-radius: 50%;
    overflow: hidden;
    z-index: 20;

    @media @landscape and (max-height: 400px) {
        width: 76%;
        height: calc(70% - 0px);
        left: 12%;
    }

    .tooltip {
        position: fixed;
        background-color: white;
        box-shadow: 0 8px 50px 2px rgba(0, 0, 0, 0.5);
        width: 130px;
        padding: 15px;
        z-index: 70;
        width: 190px;
        // right: 40px;
        transform: translate3d(-40px, -23px, 0);
        .radiusMid;
        transition: 0.5s;
        opacity: 0;
        transition-delay: 0.3s;
        pointer-events: none;

        &:after {
            content: '';
            position: absolute;
            right: -8px;
            top: 20px;
            width: 0;
            height: 0;
            border-style: solid;
            border-width: 8px 0 8px 8px;
            border-color: transparent transparent transparent #ffffff;
            z-index: 5;
        }

        &.visible {
            opacity: 1;
            transition-delay: 0s;
        }
    }

    .infos {
        width: 20px;
        height: 20px;
        border-radius: 50%;
        border: 1px solid @dark;
        .flex-center;
        font-size: 18px;
        cursor: pointer;
        transition: 0.3s;

        &:hover {
            background-color: @dark;
            color: white;
        }
    }

    [container] {
        position: absolute;
        left: 0;
        top: 80%;
        height: 100%;
        width: 100%;
        background-color: fade(white, 80%);
        transition: 0.5s ease;

        @media (min-width: 520px) {
            top: 90%;
        }

        &:after {
            content: '';
            position: absolute;
            left: 50%;
            top: 25%;
            // right: 50px;
            height: ~'calc(100% - 24px)';
            width: 1px;
            background-color: @dark;
        }

        .button.open {
            position: absolute;
            top: 0;
            left: 50%;
            transform: translateX(-50%);
            transition: 0.3s;
            height: auto;
            width: 100%;
            z-index: 5;
            // background-color: fade(red, 10%);
            text-align: center;

            padding-top: 5px;

            flex-wrap: wrap;
            justify-content: center;

            @media @landscape and (max-height: 400px) {
                font-size: 11px;
                padding-top: 5px;
                padding-bottom: 5px;
            }

            .value {
                font-weight: 900;
                padding-left: 5px;
                margin-left: 5px;
                .border-l;
            }

            .icons {
                position: relative;
                width: 100%;
                top: -5px;
            }

            .icon {
                // font-size: 40px;
                color: @black;

                @media @landscape and (max-height: 400px) {
                    padding-top: 3px;
                }
            }
        }
    }

    &[open] {
        [container] {
            top: 0%;

            .button.open {
                padding-top: 7%;

                .caption,
                .value {
                    opacity: 0;
                }
            }
        }
    }

    &[template='row'] {
        flex-direction: row;
        bottom: -40px;
    }

    &[template='table'] {
        bottom: -130px;
    }

    &:hover {
        color: black;

        .btn {
            &:before {
                opacity: 0.4;
            }

            &:hover {
                &:before {
                    opacity: 1;
                }
            }
        }
    }

    [block] {
        display: flex;
        align-items: center;
        justify-content: center;
        padding-right: 50px;
        z-index: 5;

        .cell {
            padding: 1px 10px;
            line-height: 1.1;

            &.icon {
                width: 35px;
                height: 35px;
                padding: 0;
            }

            &.caption {
                width: 110px;
                text-align: right;
                .flex-row;
                justify-content: flex-end;
            }

            &.value {
                width: 50px;
                font-weight: 900;
                font-size: 15px;
                padding-right: 0;
            }

            &.recalculate {
                cursor: pointer;
            }
        }
    }

    .btn {
        margin: 0;
    }

    .icon.load {
        position: relative;
        pointer-events: none;

        &:after {
            content: '';
            width: 15px;
            height: 15px;
            border-radius: 50%;
            border-style: solid;
            border-width: 2px;
            border-color: fade(@white, 75%) fade(@white, 75%) fade(@black, 75%) fade(@black, 75%);
            animation: load 1s linear infinite;
            display: inline-block;
            position: absolute;
            top: 50%;
            left: 50%;

            @keyframes load {
                0% {
                    transform: translate(-50%, -50%) rotate(0deg);
                }

                100% {
                    transform: translate(-50%, -50%) rotate(360deg);
                }
            }
        }
    }
}
</style>
